import { render } from "./no-data.vue?vue&type=template&id=9ec73778"
import script from "./no-data.vue?vue&type=script&lang=js"
export * from "./no-data.vue?vue&type=script&lang=js"

import "./no-data.vue?vue&type=style&index=0&id=9ec73778&lang=scss"

import exportComponent from "/Users/admin/Desktop/Project/jy-dashboard-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__